import {
    KEYWORD_GENERATOR_TOOL_SET_COUNTRY,
    KEYWORD_GENERATOR_TOOL_SET_DURATION,
    KEYWORD_GENERATOR_TOOL_SET_SEED_KEYWORD,
    KEYWORD_GENERATOR_TOOL_SET_WEBSOURCE,
    KEYWORD_GENERATOR_TOOL_SET_BOOLEAN_SEARCH_TERM,
} from "../../action_types/keyword_generator_tool_action_types";

interface IKeywordGeneratorToolState {
    seedKeyword: string | null;
    country: number | null;
    duration: string | null;
    webSource: string | null;
    keys: string | null;
}

const keywordGeneratorToolDefaultState: IKeywordGeneratorToolState = {
    seedKeyword: null,
    country: null,
    duration: null,
    webSource: null,
    keys: null,
};

export const keywordGeneratorToolReducer = (
    state: IKeywordGeneratorToolState = keywordGeneratorToolDefaultState,
    action: { type?: string; [key: string]: FixmeType },
) => {
    switch (action.type) {
        case KEYWORD_GENERATOR_TOOL_SET_BOOLEAN_SEARCH_TERM:
            return {
                ...state,
                booleanSearchTerms: action.booleanSearchTerms,
            };
        case KEYWORD_GENERATOR_TOOL_SET_SEED_KEYWORD:
            return {
                ...state,
                seedKeyword: action.seedKeyword,
            };
        case KEYWORD_GENERATOR_TOOL_SET_COUNTRY:
            return {
                ...state,
                country: action.country,
            };
        case KEYWORD_GENERATOR_TOOL_SET_DURATION:
            return {
                ...state,
                duration: action.duration,
            };
        case KEYWORD_GENERATOR_TOOL_SET_WEBSOURCE:
            return {
                ...state,
                webSource: action.webSource,
            };
        default:
            return state;
    }
};
